module.exports = __webpack_public_path__ + "static/media/icon_sidebar_chat.57ed2ff9.svg";